import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=009b95be&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&lang=js"
export * from "./Diagnostic.vue?vue&type=script&lang=js"
import style0 from "./Diagnostic.vue?vue&type=style&index=0&id=009b95be&prod&lang=scss&scoped=true"
import style1 from "./Diagnostic.vue?vue&type=style&index=1&id=009b95be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b95be",
  null
  
)

export default component.exports